import { Link } from "react-router-dom";
import { Icon, type IconName } from "./Icon";
import "./styles/IntroSection.css";

interface Pillar {
  icon: IconName;
  title: string;
  description: string;
}

const PILLARS: Pillar[] = [
  { icon: "speak", title: "Communicate", description: "Give your child a voice with a talking board of clear symbols and your own photos, built around the words they need." },
  { icon: "profile", title: "Organise", description: "Keep what helps your child, their key dates and the meetings that matter in one place, and share it in a tap." },
  { icon: "heart", title: "Connect", description: "Bring the whole family along, find answers in plain-English guides, and talk to other families who understand." },
];

export function IntroSection() {
  return (
    <section className="section intro container" aria-labelledby="intro-title">
      <div className="section__head section__head--centered">
        <p className="eyebrow">What is SENfully?</p>
        <h2 id="intro-title" className="section__title">One place for your child and your family</h2>
        <p className="section__lead">
          Raising a child with SEND can mean a communication app, a folder of reports, a calendar of meetings and a group chat for every
          relative. SENfully brings them together in one calm app, made for UK families.
        </p>
      </div>

      <div className="intro__pillars">
        {PILLARS.map((pillar) => (
          <article key={pillar.title} className="intro__pillar">
            <span className="intro__icon"><Icon name={pillar.icon} /></span>
            <h3>{pillar.title}</h3>
            <p>{pillar.description}</p>
          </article>
        ))}
      </div>

      <div className="intro__more">
        <Link to="/features" className="btn btn--ghost">
          Explore every feature
          <Icon name="arrow-right" size={18} />
        </Link>
      </div>
    </section>
  );
}
